module.exports = __webpack_public_path__ + "static/premium_parter-acf404fd2ec4d96107bd82a1897f93f6.jpg";